import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { MqttConnectionState } from "ngx-mqtt";
import { from, of } from "rxjs";
import {
  catchError,
  filter,
  map,
  switchMap,
  take,
  tap,
  withLatestFrom,
} from "rxjs/operators";
import { Plant } from "src/model/class/general classes/plant";
import { BIGGuestData } from "src/model/class/telegram classes/big-guest-data";
import { BIGDeviceOperationMode } from "src/components/shared-components/enum/enumDevice";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import {
  DeviceCardListStoreAction,
  StorageNativeStoreAction,
} from "src/components/shared-components/enum/enumStoreAction";
import { DeviceCardList } from "src/model/interface/device-card-list";
import { DeviceList } from "src/model/interface/device-list";
import { DeviceValidListInfo } from "src/model/interface/device-valid-list-info";
import { GenericDeviceCardListStore } from "src/model/interface/generic-device-card-list-store";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import { GenericUserData } from "src/model/interface/generic-user-data";
import { DeviceService } from "src/service/device.service";
import { LoggerService } from "src/service/logger.service";
import { MqttClientService } from "src/service/mqtt-client.service";
import { ValidListHandlerService } from "src/service/valid-list-handler.service";
import {
  deviceCardAddCodeCardOwnerInValidListAction,
  deviceCardAddCodeInValidListStartAction,
  deviceCardCompleteLoadAndSubscribeGuestDataServerConfirmationAddressesAction,
  deviceCardCSkipSubscribeGuestDataServerConfirmationAddressesAction,
  deviceCardEditExistingCodeInValidListAction,
  deviceCardInvalidGuestDataTelegramAction,
  deviceCardListErorGenericPopulationAction,
  deviceCardListPopulateStartErrorHandlingAction,
  deviceCardRemoveCodeFromValidListAction,
  deviceCardSkippedPopulateValidListAction,
  deviceCardSkippedRemoveCodeRequestAction,
  deviceCardStartLoadAndSubscribeGuestDataServerConfirmationAddressesAction,
  deviceCardUnsetKeyStorage,
  deviceCardValidListPopulatedAction,
  deviceCardValidListPopulatedOldDataAction,
  deviceCardValidListSuccessfullLoadedAction,
} from "../actions/device-card.actions";
import { historyTransitRemoveExistingTransitAction } from "../actions/history-transit.actions";
import { currentUserData } from "../selectors/authentication.selectors";
import { listDeviceCard } from "../selectors/device-card.selector";
import { listGateway } from "../selectors/gateway.selectors";
import { selectedPlant } from "../selectors/plant.selectors";
import { CustomerStaff } from "src/model/class/general classes/customer-staff";
import { CustomerStaffService } from "src/service/customer-staff.service";
import { async } from "rxjs/internal/scheduler/async";

/**
 * Handle generic side ngrx effect from device card action
 */
@Injectable()
export class DeviceCardEffects {
  private _logContext: string = "Device-card.effect";

  /**Data returned from last invocation of "getDeviceValidListInfo()" API call. It is used in order to port data between different effects */
  private _validListFromApiCall: DeviceValidListInfo = null;

  constructor(
    private _actions$: Actions,
    private _store: Store,
    private _deviceService: DeviceService,
    private _validListHandlerService: ValidListHandlerService,
    private _mqttClientService: MqttClientService,
    private _customerStaffService: CustomerStaffService,
    private _loggerService: LoggerService
  ) {
  }

  /**
   * Effect who catch main event and unset specific server key storage
   */
  public deviceCardUnsetKeyEffect = createEffect(() =>
    this._actions$.pipe(
      ofType(StorageNativeStoreAction.STORAGE_UNSET_ALL_AUTH_KEY),
      map((action) => deviceCardUnsetKeyStorage())
    )
  );

  /**
   * Effet attached to ngrx store init, then start init valid list initializatiojn
   */
  public deviceCardStartPopulateValidListEffects = createEffect(() =>
    this._actions$.pipe(
      ofType(DeviceCardListStoreAction.DEVICE_CARD_START_POPULATE_VALID_LIST),
      withLatestFrom(
        this._store.select(currentUserData),
        this._store.select(selectedPlant)
      ),
      filter(
        (combinedObject) =>
          !!(combinedObject[1] as GenericUserData)?.currentUser
      ),
      switchMap((action: any) => {
        const selectedPlant: Plant = action[2];

        /*
                if (
                  selectedPlant.operativeMode ===
                  BIGDeviceOperationMode.ACCESS_CONTROL_MODE ||
                  selectedPlant.operativeMode ===
                  BIGDeviceOperationMode.DIGITAL_PLACE_MODE
                ) {
        */
        if (1) {
          let includeCards = false;
          if (
            selectedPlant?.operativeMode ===
            BIGDeviceOperationMode.ACCESS_CONTROL_MODE
          ) {
            includeCards = true;
          }
          this._validListFromApiCall = null;

          //TO BE USE FOR TESTING ON BROWSER ONLY
          //includeCards = true;

          return this._deviceService.getDeviceValidListInfo(includeCards).pipe(
            switchMap((deviceValidListInfo: DeviceValidListInfo) => {

              this._validListFromApiCall = deviceValidListInfo;

              return [deviceCardValidListSuccessfullLoadedAction()];
            }),
            catchError((error: HttpErrorResponse) =>
              of(deviceCardListPopulateStartErrorHandlingAction(error))
            )
          );
        } else {
          return of(deviceCardSkippedPopulateValidListAction());
        }
      })//
    )
  );



  /**
   * Effet handling the successfull loading of Valid List data through API call
   */
  public deviceCardValidListSuccessfullLoadedEffects = createEffect(() =>
    this._actions$.pipe(
      ofType(
        DeviceCardListStoreAction.DEVICE_CARD_VALID_LIST_SUCCESSFULL_LOADED
      ),
      switchMap((action: any) => {
        return [
          deviceCardValidListPopulatedAction({
            listCard: this._validListFromApiCall.listCards,
            listDevices: this._validListFromApiCall.listDevices,
            listCardOwners: this._validListFromApiCall.listCardOwners
          }),
          deviceCardStartLoadAndSubscribeGuestDataServerConfirmationAddressesAction(
            {
              listDevices: this._validListFromApiCall.listDevices,
            }
          ),
        ];
      })
    )
  );
  //

  /**
   * Effect handling error in valid list loading
   */
  public deviceCardStartPopulateStartErrorHandlingEffects = createEffect(() =>
    this._actions$.pipe(
      ofType(
        DeviceCardListStoreAction.DEVICE_CARD_VALID_LIST_POPULATED_START_ERROR_HANDLING
      ),
      withLatestFrom(
        this._store.select(currentUserData),
        this._store.select(listDeviceCard)
      ),
      filter(
        (combinedObject) =>
          !!(combinedObject[1] as GenericUserData)?.currentUser
      ),
      switchMap((action) => {
        const httpError: HttpErrorResponse = action[0] as HttpErrorResponse;
        const deviceCardStore: GenericDeviceCardListStore = action[2];

        //When API return erro, but previos snapshot store
        //was populate correctly, it returns previous card list
        //otherwiser return error

        //if (deviceCardStore.loaded && !deviceCardStore.error) {
        if (deviceCardStore.loaded && !deviceCardStore.error) {
          return [
            deviceCardValidListPopulatedOldDataAction({
              oldListCard: deviceCardStore.validList || [],
              oldDeviceList: deviceCardStore.deviceList || [],
              oldCardOwnerList: deviceCardStore.cardOwnerList || []
            }),
            deviceCardStartLoadAndSubscribeGuestDataServerConfirmationAddressesAction(
              {
                listDevices: deviceCardStore.deviceList,
              }
            ),
          ];
        } else {
          return [deviceCardListErorGenericPopulationAction()];
        }
      })
    )
  );

  /**
   * Handle new guest data object to add/update/remove code in valid list object handler
   */
  public deviceCardListHandleNewGUestDataEffect = createEffect(() =>
    this._actions$.pipe(
      ofType(DeviceCardListStoreAction.DEVICE_CARD_HANDLE_NEW_GUEST_TELEGRAM),
      withLatestFrom(
        this._store.select(currentUserData),
        this._store.select(listDeviceCard)
      ),
      filter(
        (combinedObject) =>
          !!(combinedObject[1] as GenericUserData)?.currentUser
      ),
      map((combinedObject: any) => {
        const guestDataTelegram: BIGGuestData = new BIGGuestData(
          combinedObject[0].guestDataTelegram
        );

        const idDevice: number = combinedObject[0].idDevice || 0;
        const listDeviceCard: Array<DeviceCardList> = combinedObject[2]
          .validList as Array<DeviceCardList>;
        const currentCardOwnerList: Array<CustomerStaff> = combinedObject[2].cardOwnerList as Array<CustomerStaff>;

        const foundedDeviceCard: DeviceCardList = listDeviceCard.find(
          (deviceCard: DeviceCardList) =>
            deviceCard.code === guestDataTelegram.code &&
            deviceCard.idDevice === idDevice
        );

        //CASE 1: Telegram is invalid
        if (!guestDataTelegram.isValidTelegram) {
          return deviceCardInvalidGuestDataTelegramAction();
        } else if (guestDataTelegram.isDeleteRequest && !foundedDeviceCard) {
          //CASE 2: Telegram is valid, its goal is TO-DELETE but device-card is NOT FOUND 
          return deviceCardSkippedRemoveCodeRequestAction();
        } else if (guestDataTelegram.isDeleteRequest) {
          //CASE 3: Telegram is valid, its goal is TO-DELETE AND device-card is  FOUND 
          return deviceCardRemoveCodeFromValidListAction({
            idDevice,
            code: guestDataTelegram.code,
            IDCardOwner: foundedDeviceCard.cardOwnerID
          });
        } else {
          const deviceCardObject: DeviceCardList =
            this._validListHandlerService.guestDataObjectToDeviceCardListObject(
              idDevice,
              guestDataTelegram
            );

          if (foundedDeviceCard) {
            //CASE 4: Telegram is valid and refer to EXISTING device-card (UPDATE that device-card) 
            return deviceCardEditExistingCodeInValidListAction({
              updateDeviceCardValidListCode: deviceCardObject,
            });
          } else {
            //CASE 5: Telegram is valid and refer to NOT-EXISTING device-card (INSERT that device-card) 
            return deviceCardAddCodeInValidListStartAction({
              newDeviceCardValidListCode: deviceCardObject,
              currentCardOwnerList: currentCardOwnerList
            });
          }
        }
      })
    )
  );

  /**
   * Handle procedure to update the "deviceCardList" feature with a new code. This include:
   * * The insertion of a new code into "validList"
   * * The possible insertion of a new customerStaff into "cardOwnerList": the customerStaff associated to the to-be-inserted code is retrieved from
   *    the server via API; if no such cardOwner is present in the list, it is added too.
   */
  public deviceCardListHandleNewGUestDataEffec1t = createEffect(() =>
    this._actions$.pipe(
      ofType(DeviceCardListStoreAction.DEVICE_CARD_NEW_CODE_ADDITION_START),
      withLatestFrom(
        this._store.select(currentUserData),
      ),
      filter(
        (combinedObject) =>
          !!(combinedObject[1] as GenericUserData)?.currentUser
      ),
      switchMap((combinedObject: any) => {

        let newValidListCode: DeviceCardList = combinedObject[0].newDeviceCardValidListCode as DeviceCardList;
        let cardOwnerID: number = newValidListCode.cardOwnerID;
        let currentCardOwnerList: Array<CustomerStaff> = combinedObject[0].currentCardOwnerList as Array<CustomerStaff>;
        let found: boolean = false;
        let newValidListCodeOwner: Array<CustomerStaff> = new Array<CustomerStaff>();
        const quesryString: string = "ownedCardCode=" + newValidListCode.code;

        const returnedAction = from(this._customerStaffService.getCustomerByQueryString(quesryString)).pipe(
          switchMap((newValidListCodeOwnerList: CustomerStaff[]) => {

            if (newValidListCodeOwnerList.length > 0) {
              cardOwnerID = newValidListCodeOwnerList[0].id;

              for (let i = 0; i < currentCardOwnerList.length && !found; i++) {
                if (currentCardOwnerList[i].id === newValidListCodeOwnerList[0].id) {
                  found = true;
                }
              }

            }

            if (!found) {
              newValidListCodeOwner = newValidListCodeOwnerList;
            }
            const newValidCard = { ...newValidListCode, cardOwnerID };

            return [deviceCardAddCodeCardOwnerInValidListAction({
              newDeviceCardValidListCode: newValidCard,
              newCardOwner: newValidListCodeOwner
            }
            )]


          })
        );

        return returnedAction;
      }
      )
    )
  );


  /**
   * handle load and subscribe of address guest data
   */
  public deviceCardLoadAndSubscribeGuestDataAddressEffect = createEffect(() =>
    this._actions$.pipe(
      ofType(
        DeviceCardListStoreAction.DEVICE_CARD_LOAD_SUBSCRIBE_GUEST_DATA_SERVER_CONFIRMATION_ADDRESSES
      ),
      withLatestFrom(this._store.select(currentUserData)),
      filter(
        (combinedObject) =>
          !!(combinedObject[1] as GenericUserData)?.currentUser
      ),
      switchMap((combinedObject) =>
        this._store.select(listGateway).pipe(
          filter(
            (listGatewayStore: GenericStoreApiData) => listGatewayStore?.loaded
          ),
          filter(
            (listGatewayStore: GenericStoreApiData) =>
              !(
                listGatewayStore.errorGeneric ||
                listGatewayStore.errorNotYetImplemented
              )
          ),
          tap((listGatewayStore: GenericStoreApiData) => {
            if (listGatewayStore.isOldDataInUse) {
              this._loggerService.log(
                LogLevel.LOG_INFO,
                this._logContext,
                "_store.select(listGateway)",
                "deviceCardLoadAndSubscribeGuestDataAddressEffect",
                "We are using old data!!"
              );
            }
          }),
          take(1),
          map(() => combinedObject)
        )
      ),
      switchMap((combinedObject: any) => {

        if (this._mqttClientService.Status === MqttConnectionState.CONNECTED) {
          return from(
            this._validListHandlerService.loadAccessControlAddressesAndSubscribe(
              combinedObject[0].listDevices.map((item) => item.idDevice)
            )
          ).pipe(
            map(() =>
              deviceCardCompleteLoadAndSubscribeGuestDataServerConfirmationAddressesAction()
            )
          );
        } else {
          return of(
            deviceCardCSkipSubscribeGuestDataServerConfirmationAddressesAction()
          );
        }
      })
    )// //
  );

  /**
   * handle new telegram server confirmation address
   */
  public deviceCardHandleNewServerConfirmation = createEffect(() =>
    this._actions$.pipe(
      ofType(
        DeviceCardListStoreAction.DEVICE_CARD_SERVER_CONFIRMATION_ADDRESS_RECEIVED
      ),
      withLatestFrom(
        this._store.select(currentUserData),
        this._store.select(selectedPlant)
      ),
      filter(
        (combinedObject) =>
          !!(combinedObject[1] as GenericUserData)?.currentUser
      ),
      switchMap((action: any) => {
        const selectedPlant: Plant = action[2];
        const idDevice: number = action[0].idDevice;
        const serverConfirmationTelegram: string =
          action[0].serverConfirmationTelegram;

        return of(
          historyTransitRemoveExistingTransitAction({
            idPlant: selectedPlant.ID,
            idDevice,
            serverConfirmationTelegram,
          })
        );
      })
    )
  );
}
